const API_BASE = process.env.REACT_APP_API_URL;

/**
 * Sends student answer to the backend for marking via Gemini.
 * @param {Object} question    - Question object from QuestionData.json
 * @param {Object} steps       - { summary, point1, point2, conclusion }
 * @param {string} markType    - '6-mark' | '9-mark'
 * @param {string} token       - Auth0 access token
 * @param {number} timeElapsed - Seconds spent on the question
 * @returns {Promise<Object>}  Parsed feedback object
 */
export async function markAnswer(question, steps, markType = '6-mark', token, timeElapsed = 0) {
  const res = await fetch(`${API_BASE}/api/mark-answer`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ question, steps, markType, provider: 'gemini', timeElapsed }),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `Server error: ${res.statusText}`);
  }

  return res.json();
}
